import React from 'react';
import PropTypes from 'prop-types';
import LPCard from '../Card';
import { useClassName } from 'common/hooks';

export default function CarouselCard({ setPaused, slide, refs, handleTrack }) {
  const classNames = useClassName('CLPCarousel');
  return (
    <div
      className={classNames('slide')}
      onMouseOver={() => setPaused(true)}
      onMouseOut={() => setPaused(false)}>
      <LPCard item={slide} refs={refs} handleTrack={handleTrack} />
    </div>
  );
}

CarouselCard.propTypes = {
  setPaused: PropTypes.func,
  slide: PropTypes.object.isRequired,
  refs: PropTypes.object,
  handleTrack: PropTypes.func,
};

CarouselCard.defaultProps = {
  setPaused: null,
  refs: null,
  handleTrack: () => {},
};
